import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

const placementOptions = [
  { label: "上", value: "top" },
  { label: "左上", value: "topLeft" },
  { label: "右上", value: "topRight" },
  { label: "下", value: "bottom" },
  { label: "左下", value: "bottomLeft" },
  { label: "右下", value: "bottomRight" },
  { label: "左", value: "left" },
  { label: "左上侧", value: "leftTop" },
  { label: "左下侧", value: "leftBottom" },
  { label: "右", value: "right" },
  { label: "右上侧", value: "rightTop" },
  { label: "右下侧", value: "rightBottom" },
];

export const PopoverMeta: ComponentMeta = {
  componentName: "Popover",
  package: "@mijadesign/web",
  title: "气泡卡片",
  description: "弹出卡片式的内容容器",
  category: ComponentCategory.FEEDBACK,
  icon: "MessageOutlined",
  canHaveChildren: true,
  visibleInComponentPanel: true,
  designToken: {
    fields: [
      {
        name: "titleMinWidth",
        label: "标题最小宽度",
        type: "number",
        min: 0,
        max: 600,
      },
      {
        name: "zIndexPopup",
        label: "弹层层级",
        type: "number",
        min: 0,
        max: 9999,
      },
    ],
  },
  editorDnd: {
    dropMode: "slot",
    slotConfig: {
      areas: [
        { key: "trigger", label: "触发元素" },
        { key: "content", label: "气泡内容" },
      ],
      defaultArea: "content",
    },
  },
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "content",
      label: "内容兜底",
      type: PropType.STRING,
      description: "未拖入气泡内容插槽时使用",
      group: "基础",
    },
    {
      name: "trigger",
      label: "触发方式",
      type: PropType.ENUM,
      defaultValue: "hover",
      options: [
        { label: "悬停", value: "hover" },
        { label: "点击", value: "click" },
        { label: "聚焦", value: "focus" },
        { label: "右键", value: "contextMenu" },
      ],
      group: "行为",
    },
    {
      name: "placement",
      label: "弹出位置",
      type: PropType.ENUM,
      defaultValue: "top",
      options: placementOptions,
      group: "布局",
    },
    // {
    //   name: "open",
    //   label: "是否显示",
    //   type: PropType.BOOLEAN,
    //   group: "状态",
    // },
    {
      name: "arrow",
      label: "显示箭头",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "destroyOnHidden",
      label: "隐藏后销毁",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "行为",
    },
    {
      name: "fresh",
      label: "隐藏时刷新",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "行为",
    },
    {
      name: "color",
      label: "背景色",
      type: PropType.COLOR,
      group: "样式",
    },
    {
      name: "overlayClassName",
      label: "弹层类名",
      type: PropType.STRING,
      group: "样式",
    },
    {
      name: "overlayStyle",
      label: "弹层样式",
      type: PropType.OBJECT,
      group: "样式",
    },
    {
      name: "zIndex",
      label: "层级",
      type: PropType.NUMBER,
      min: 0,
      group: "样式",
    },
  ],
  defaultProps: {
    title: "标题",
    content: "卡片内容",
    trigger: "hover",
    placement: "top",
    arrow: true,
    destroyOnHidden: false,
    fresh: false,
  },
  preview: [
    {
      title: "悬停提示",
      props: {
        title: "提示标题",
        content: "这里展示补充说明内容",
        trigger: "hover",
        placement: "top",
        children: "移入查看",
      },
    },
    {
      title: "点击弹出",
      props: {
        title: "操作说明",
        content: "点击触发后展示详细内容",
        trigger: "click",
        placement: "right",
        children: "点击查看",
      },
    },
  ],
  docLinks: [
    {
      title: "Popover 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/Popover",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "antd",
    exportName: "Popover",
  },
  snippet: {
    componentName: "Popover",
    package: "antd",
    props: {
      title: "标题",
      content: "卡片内容",
      trigger: "hover",
      placement: "top",
    },
  },
};
